import { Action } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { CompanyTable } from "@/components/data-table/predefined/company-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;

export function CompanyView() {
  const { t } = useTranslation(["common", "masterdata"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "Company");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
        showRestore: false,
      };

  return (
    <Can I="read" a="Company">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("common:Companies")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <CompanyTable pageSize={DEFAULT_PAGE_SIZE} showCreateButton={canManage} defaultRowActions={defaultRowActions} />
      </CenteredLayout>
    </Can>
  );
}
